import {Stack, Typography} from '@mui/material'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

type GrindingCircuitDeleteMessageProps = {
  title: string | null
  label: string
}

export const GrindingCircuitDeleteMessage: FC<GrindingCircuitDeleteMessageProps> = ({
  title,
  label
}) => {
  const {t} = useTranslation()

  return (
    <Stack spacing={3} pt={1}>
      <Typography color="grey.700" mt={1}>
        {t('plantSetup.grindingCircuit.label.sureToDelete')}
      </Typography>

      <Stack>
        {title && <Typography mt={1}>{title}</Typography>}
        <Typography variant="caption">{label}</Typography>
      </Stack>
    </Stack>
  )
}
